<template>
  <div>
    <div
      style="
        padding: 30px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
      "
    >
      <div
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 20px;
        "
      >
        我的费用
      </div>
      <div style="display: flex; flex-wrap: wrap">
        <div
          class="grid-content bg-purple"
          style="margin-right: 41px; margin-bottom: 10px; min-width: 460px"
        >
          <span
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 20px;
            "
          >
            费用确认日期
          </span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div
          class="grid-content bg-purple"
          style="
            margin-bottom: 10px;
            min-width: 310px;
            margin-right: 41px;
            display: flex;
            align-items: center;
          "
        >
          <span
            style="
              font-size: 14px;
              min-width: 50px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 20px;
            "
          >
            运单号
          </span>
          <el-input
            placeholder="请输入运单号"
            v-model.trim="nos"
            clearable
            style="width: 240px"
          >
          </el-input>
        </div>
        <div class="grid-content bg-purple" style="margin-right: 20px">
          <span
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 20px;
            "
          >
            费用状态
          </span>
          <el-select style="width: 107px" v-model="state" placeholder="请选择">
            <el-option
              v-for="item in statusList"
              :key="item.state"
              :label="item.name"
              :value="item.state"
            >
            </el-option>
          </el-select>
        </div>
        <div class="grid-content bg-purple" style="margin-right: 20px">
          <span
            style="
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-right: 20px;
            "
          >
            发票状态
          </span>
          <el-select style="width: 107px" v-model="invoiceStatus" placeholder="请选择">
            <el-option
              v-for="item in invoiceStatusList"
              :key="item.state"
              :label="item.name"
              :value="item.state"
            >
            </el-option>
          </el-select>
        </div>
        <div class="grid-content bg-purple">
          <el-button
            @click="enterSearch(1)"
            style="margin-left: 20px;height:32px;line-height:2px;"
            type="primary"
            @keyup.enter="enterSearch"
            >查询</el-button
          >
        </div>
      </div>
      <el-button @click="toPay()"
                 :disabled="!!isCanMergePay"
                 :title="isCanMergePay?isCanMergePay:''"
                 style="margin: 36px 0 15px 0" type="primary">合并支付</el-button>

      <el-button @click="clickMultipleInvoices()"
                 :disabled="!!isCanMergeInvoice"
                 :title="isCanMergeInvoice?isCanMergeInvoice:''"
                 style="margin: 36px 0 15px 10px;" type="success">合并开票</el-button>
      <div>
        <!-- table -->
        <div style="max-height: 500px; overflow: auto">
          <table
            class="basic-table"
            style="width: 100%; border: 1px solid #e7e7e7"
          >
            <thead>
              <tr
                style="
                  background-color: #e7e7e7;
                  height: 35px;
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #9a9a9a;
                "
              >
                <th style="width: 50px; border: 1px solid #e7e7e7">
                  <!-- 全列表全选 -->
                  <el-checkbox
                    :value="isAllSelect"
                    @change="clickMainAllSelect()"
                  />
                </th>
                <th style="width: 50px">序号</th>
                <th v-for="(item, index) in title" :key="index">{{ item }}</th>
              </tr>
            </thead>
            <tbody style="text-align: center" v-if="list.length > 0">
              <tr
                style="min-height: 40px; border: 1px solid #e7e7e7"
                v-for="(listItem, listIndex) in list"
                :key="listIndex"
              >
                <td class="tableBorderMy" style="width: 50px">
                  <!-- 全选 -->
                  <el-checkbox
                    v-if="currentSelectList[listIndex].showChecked"
                    :value="currentSelectList[listIndex].checked"
                    :disabled="currentSelectList[listIndex].disabled"
                    @change="clickRowAllSelect(currentSelectList[listIndex], listIndex)"
                  />
                </td>
                <td class="tableBorderMy">{{ listIndex + 1 }}</td>
                <!-- 单号 -->
                <td class="tableBorderMy">{{ listItem.nos }}</td>
                <!-- 名称 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    <!-- 单个选择 -->
                    <div style="display: flex; justify-content: center">
                      <!-- 最外居中内容 -->
                      <div style="display: flex; text-align: start">
                        <!-- 给俩个div固定宽度 -->
                        <div style="width: 16px; margin-right: 7px">
                          <el-checkbox
                            v-if="currentSelectList[listIndex].children[itemIndex].showChecked"
                            :value="currentSelectList[listIndex].children[itemIndex].checked"
                            :disabled="currentSelectList[listIndex].children[itemIndex].disabled"
                            @change="clickItemSelect(currentSelectList[listIndex].children[itemIndex],itemIndex,currentSelectList[listIndex],listIndex)"
                          />
                        </div>
                        <div
                          style="
                            width: 120px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                          "
                        >
                          <span> {{ singleItem.feeName }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- 判断是否留border-bottom -->
                    <!-- !(listItem.detailList.length - 1 == itemIndex) -->
                  </div>
                </td>

                <!-- 预报单价 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.priceBefore }}
                  </div>
                </td>
                <!-- 预报数量 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.pieceBefore }}
                  </div>
                </td>
                <!-- 预估金额 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.amountBefore }}
                  </div>
                </td>
                <!-- 实际金额 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.amount }} {{ singleItem.currency }}
                  </div>
                </td>
                <!-- 实际单价 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.priceReal }}
                  </div>
                </td>
                <!-- 实际数量 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.pieceReal }}
                  </div>
                </td>
                <td>
                  <div
                    style="height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.remarks }}
                  </div>
                </td>
                <!-- 时间 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                    {{ singleItem.inputtime }}
                  </div>
                </td>
                <!-- 发票状态 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                  <template v-if="singleItem.amount >= 0">
                    {{ invoiceStatusMapObject[singleItem.invoiceState]||'状态异常'}}
                  </template>
                    <!-- {{ invoiceStatusMapObject[singleItem.invoiceState]||'状态异常'}} -->
                  </div>
                </td>

                <!-- 账单状态 -->
                <td>
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      border-right: 1px solid #e7e7e7;
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >

                    <template v-if="singleItem.amount >= 0">
                      <span v-if="singleItem.newStatus == '1'">待支付</span>
                      <span v-if="singleItem.newStatus == '2'">已完成</span>
                      <span v-if="singleItem.newStatus == '3'">已取消</span>
                      <!-- <span v-if="singleItem.status == '3'">已完成</span>
                      <span v-if="singleItem.status == '4'">支付中</span> -->
                    </template>
                  </div>
                </td>
                <!-- 操作 -->
                <td style="text-align: left;">
                  <!--  display: flex;
                      justify-content: center; -->
                  <div
                    style="
                      height: 38px;
                      line-height: 38px;
                      padding-left: 10px;
                      width: 130px
                    "
                    v-for="(singleItem, itemIndex) in listItem.detailList"
                    :key="itemIndex"
                    :class="{
                      tableBorderMyBtn: !(
                        listItem.detailList.length - 1 ==
                        itemIndex
                      ),
                    }"
                  >
                   <template v-if="singleItem.amount >= 0">
                     <!--<el-link v-if="singleItem.feeName"-->
                              <!--@click="getDetail(listIndex)"-->
                              <!--class="table-button"-->
                              <!--type=""-->
                              <!--:underline="false">费用详情</el-link>-->
                              <el-link v-if="singleItem.newStatus == 1 && singleItem.amount > 0"
                              @click="toPay(singleItem.id, '1', singleItem.cnyAmount)"
                              class="table-button"
                              type="primary"
                              :underline="false">去支付</el-link>
                      <!-- 未开票的并且（未支付  或者 （ 支付完成并且对公开票的）） -->
                      <!-- <el-link v-if="(singleItem.invoiceState === 0 && (singleItem.newStatus == 1 || (singleItem.newStatus == 2 && singleItem.publicTransferAccount == true)))" -->
                      <!-- 未开票的并且（未支付  或者 支付完成） -->
                      <el-link v-if="(singleItem.invoiceState === 0 && (singleItem.newStatus == 1 || singleItem.newStatus == 2))"
                              @click="toInvoice([singleItem.id],singleItem.cnyAmount,singleItem.currency)"
                              class="table-button"
                              type="success"
                              :underline="false">去开票</el-link>
                   </template>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="list.length == 0"
            style="
              line-height: 100px;
              height: 100px;
              width: 100%;
              color: #999;
              text-align: center;
            "
          >
            暂无数据
          </div>
          <!-- 详情 -->
          <el-dialog
            class="Mydialog"
            title="费用详情"
            :visible.sync="dialogVisible"
            width="700px"
            center
          >
            <div style="display: flex">
              <el-table
                :data="detail"
                :header-cell-style="{
                  background: '#eef1f6',
                  color: '#606266',
                }"
                border
                align="center"
                highlight-current-row
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column
                  align="center"
                  prop="feeName"
                  label="费用类型"
                  width="180"
                >
                </el-table-column>
                <el-table-column align="center" prop="amount" label="价格">
                  <template slot-scope="scope">
                    <span v-if="scope.row.TotalCnyAmount">
                      {{ scope.row.TotalCnyAmount }} CNY
                    </span>
                    <span v-else-if="scope.row.TotalCnyAmount1">
                      {{ scope.row.TotalCnyAmount1 }}
                    </span>
                    <span v-else>
                      {{ scope.row.currency }} {{ scope.row.price }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="amount2" label="费用详情">
                  <template slot-scope="scope">
                    {{ scope.row.price }} {{ scope.row.currency }} *
                    {{ scope.row.piece }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-dialog>
        </div>
        <!-- table end -->

        <el-pagination
          style="margin-top: 20px; float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20,30,40, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {ascendingStringId} from "@/assets/js/utils";
  export default {
  data() {
    return {
      // table
      title: [
        "运单号",
        "费用名称",
        "预报单价(RMB)",
        "预报数量",
        "预估金额(RMB)",
        "实际金额(RMB)",
        "实际单价",
        "实际数量",
        "费用详情",
        "费用确认时间",
        "发票状态",
        "费用状态",
        "操作",
      ],
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 筛选
      state: "",//费用状态
      statusList: [
        {
          name: "全部",
          state: "0",
        },
        {
          name: "待支付",
          state: "1",
        },
        {
          name: "已完成",
          state: "2",
        },
        {
          name: "已取消",
          state: "3",
        },
        // {
        //   name: "已完成",
        //   state: "3",
        // },
        // {
        //   name: "支付中",
        //   state: "4",
        // },
      ],//费用状态列表
      value1: "",//费用确认日期
      nos: "",//运单号
      invoiceStatus:"",//发票状态
      invoiceStatusList:[
        {
          name: "全部",
          state: "",
        },
        {
          name: "待开票",
          state: 0,
        },
        {
          name: "开票中",
          state: 1,
        },
        {
          name: "已开票",
          state: 2,
        },
      ],
      invoiceStatusMapObject:{
        "0":"待开票",
        "1":"开票中",
        "2":"已开票",
      },
      // 单选/全选
      allSelect: false,//原 是否全选
      subListId: [],//原选择存储对象
      totalAmount: [],//原选择存储对象
      arrayIdSummary: [],//原选择存储对象

      // 新的 单选/全选
      isAllSelect:false,// 是否全选
      currentSelectList:[],// 当前页面选择列表 [{id:'',showChecked:true,checked:false,disabled:false,children:[] }]
      allSelectList:[], // 所有已选择列表 [{id:'',children:[]}]

      // 费用详情
      detail: [],
      dialogVisible: false,
    };
  },
  watch: {},
  methods: {
    // 获取详情
    getDetail(parentIndex) {
      // console.log(parentIndex);

      this.axios
        .post("/arap/getFinaArapWebDetailList", {
          beginTime: "",
          endTime: "",
          id: this.list[parentIndex].id,
          status: "",
        })
        .then(res => {
          if (res.data.code == 200) {
            // 费用
            // 获取包含币种名称
            let C = [];
            res.data.datas.forEach((i, index) => {
              if (C.indexOf(i.currency) == -1) {
                C.push(i.currency);
              }
            });
            // 获取包含币种的金额数
            let nums = [];
            let tempList = res.data.datas;
            for (let index = 0; index < C.length; index++) {
              let yesNum = [];
              for (let index2 = 0; index2 < tempList.length; index2++) {
                if (tempList[index2].currency == C[index]) {
                  // 可能会有null或空字符串的情况
                  if (
                    tempList[index2].price == null ||
                    tempList[index2].price == ""
                  ) {
                    yesNum.push(parseFloat(0));
                  } else {
                    yesNum.push(parseFloat(tempList[index2].price));
                  }
                }
              }

              nums.push(yesNum);
            }
            // 计算出个币种的总金额

            let finalCurrency = "";

            C.forEach((i, index) => {
              //  拼接字符串
              let finalNum = nums[index].reduce((prev, cur) => prev + cur);

              finalCurrency +=
                C[index] +
                " " +
                parseFloat(finalNum).toFixed(2) +
                " " +
                "+" +
                " ";
            });
            finalCurrency = finalCurrency.substr(0, finalCurrency.length - 2);

            // 折合人民币
            let TotalCnyAmount = 0;
            res.data.datas.forEach((i) => {
              TotalCnyAmount += parseFloat(i.cnyAmount);
            });
            let temp = [
              { feeName: "合计费用", TotalCnyAmount1: finalCurrency },
              {
                feeName: "折合人民币",
                TotalCnyAmount: parseFloat(TotalCnyAmount).toFixed(2),
              },
            ];
            this.detail = [...res.data.datas, ...temp];
            this.dialogVisible = true;
            return;
          }
          this.$message.info(res.data.message);
          this.dialogVisible = true;
        })
        .catch(res=>{
          console.error(res)
        })
    },
    /**
     * 分页相关
     * */
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getListByParams();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getListByParams();
    },
    // 根据参数查询
    getListByParams(type) {
      if(!localStorage.getItem("Authorization")){
        return
      }

      let user = this.sessionGetUserInfo();
      let param = {
        beginTime: "",
        endTime: "",
        nos: "",
        curPage: this.currentPage,
        customerId: user.customerid,
        pageSize: this.pageSize,
        startIndex: 0,
        status: "",
        newStatus:'',
        invoiceState: this.invoiceStatus,
      };
      if(!param.invoiceState && param.invoiceState !== 0) delete param.invoiceState;
      if(Array.isArray(this.value1) && this.value1.length>1){
        param.beginTime = this.value1[0];
        param.endTime = this.value1[1];
      }
      if (this.nos)  param.nos = this.nos;
      if (this.state && ![0,'0'].includes(this.state)) param.newStatus = this.state;

      this.axios
        .post("/arap/getFinaArapWebList", param)
        .then((res) => {
          console.log('res: ', res);

          if (res.data.code !== 200) {
            return Promise.reject(new Error(res.data.message));
          }
          let list = res.data.data.datalList;
          // list[0].detailList[0].currency = "USD"; // 测试用
          if(!Array.isArray(list)) list = [];
          this.parseCurrentPageSelect(list);
          this.list = list;
          this.total = res.data.data.totalCounts;
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res.message||'网络繁忙，请稍后重试！');
          this.list = [];
          this.total = 10;
          // 清空，不然每次都会叠加
          this.arrayIdSummary = [];
          this.totalAmount = [];
        });
    },

    // enter回车搜索
    enterSearch(){
      this.currentPage = 1;
      this.getListByParams();
    },
    // 去支付页面
    toPay(id, type, amount) {
      // 单个支付
      if (type == 1) {
        this.$router.push({
          name: "payOrder",
          params: {
            id,
            amount,
          },
        });
        return;
      }

      // 多个支付
      let temId = [];
      let totalMoney = 0;
      this.allSelectList.forEach(res=>{
        temId.push(res.id);
        totalMoney += parseFloat(res.money)
      });
      if (!temId.length > 0) {
        this.$message.info("请选择最少一个费用");
        return;
      }
      // 去重
      temId = [...new Set(temId)];
      this.$router.push({
        name: "payOrder",
        params: {
          temId,
          amount: totalMoney.toFixed(2),
        },
      });

      // console.log(id)
      //  this.$router.push("/index/Personalindex/tabelTest");
    },
    /**
     * 初始化 当前页全选初始数据
     * @param list
     */
    parseCurrentPageSelect(list = []){
      this.isAllSelect = false;
      let initList = list.map(res=>{
        let item = Object.assign({},res,{
          // id:'',
          showChecked:false,
          checked:false,
          disabled:false,
          children:[],
          //其他属性
        });
        item.children = res.detailList.map(son=>{
          let data = Object.assign({},son,{
            // id:'',
            showChecked:false,
            checked: false,
            disabled:false,
          });
          if(this.allSelectList.find(res=>res.id === son.id)) data.checked = true;
          if([1,'1'].includes(son.status)) data.showChecked = true;//支付
          if([0,'0'].includes(son.invoiceState)) data.showChecked = true;//开票
          // else data.showChecked = true;//测试用
          return data;
        });
        if(item.children.some(res=>res.showChecked === true)) item.showChecked = true;
        if(item.showChecked && !item.disabled){
          if(item.children.filter(res=>res.showChecked && !res.disabled).every(res=>res.checked === true)) item.checked = true;
        }
        return item;
      });
      this.currentSelectList = initList;
      if(initList.filter(res=>res.showChecked && !res.disabled).every(res=>res.checked === true)) this.isAllSelect = true;
      return initList;
    },
    /**
     * 点击全选（当前table）
     */
    clickMainAllSelect(){
      this.isAllSelect = !this.isAllSelect;
      let list = this.currentSelectList;
      list.forEach((res,index)=>{
        if(res.showChecked && !res.disabled) {
          this.setRowSelectStatus(res,index,this.isAllSelect);
        }
      });
    },
    /**
     * 点击全选（运单号维度）
     * @param item
     * @param index
     * @param checked
     */
    clickRowAllSelect(item,index,checked){
      this.setRowSelectStatus(...arguments);
      let checkItem = this.currentSelectList[index];
      if(checkItem.checked){
        this.judgeAllSelect()
      }else{
        this.judgeAllSelect(false);
      }
    },
    setRowSelectStatus(item,index,checked){
      let checkItem = this.currentSelectList[index];
      if(typeof checked === 'boolean'){
        checkItem.checked = checked;
      }else{
        checkItem.checked = !checkItem.checked;
      }
      let list = item.children;
      list.forEach((res,i)=>{
        if(res.showChecked && !res.disabled) this.setCheckedStatus(res,i,item,index,checkItem.checked);
      });
    },
    /**
     * 点击选中 单个费用
     * @param item
     * @param index
     * @param row
     * @param rowIndex
     * @param checked
     */
    clickItemSelect(item,index,row,rowIndex,checked){
      this.setCheckedStatus(...arguments);
      let checkItem = this.currentSelectList[rowIndex].children[index];
      if(checkItem.checked){
        this.judgeRowAllSelect(row,rowIndex);
      }else {
        this.judgeRowAllSelect(row,rowIndex,false);
      }
    },
    setCheckedStatus(item,index,row,rowIndex,checked){
      let checkItem = this.currentSelectList[rowIndex].children[index];
      if(typeof checked === 'boolean'){
        checkItem.checked = checked;
      }else{
        checkItem.checked = !checkItem.checked;
      }
      if(checkItem.checked){
        this.pushCheckedItem(item,row);
      }else {
        this.removeCheckedItem(item,row);
      }
    },
    /**
     * 添加/移除 单个服务费用 选中记录
     * @param item
     */
    pushCheckedItem(item={}){
      console.log("item==",item)
      let index = this.allSelectList.findIndex(res=>res.id === item.id);
      if(index === -1) {
        this.allSelectList.push({
          id:item.id,
          money:item.cnyAmount,
          newStatus:item.newStatus,
          currency:item.currency,
          invoiceState:item.invoiceState,
          publicTransferAccount:item.publicTransferAccount,
          payType:item.payType,
          status:item.status
        })
      }
    },
    removeCheckedItem(item={}){
      let index = this.allSelectList.findIndex(res=>res.id === item.id);
      if(index >= 0) this.allSelectList.splice(index,1);
    },
    /**
     * 判断 是否全选（运单号维度）
     * @param item
     * @param index
     * @param checked
     */
    judgeRowAllSelect(item,index,checked){
      let checkItem = this.currentSelectList[index];
      let list = checkItem.children;
      list = list.filter(res=>res.showChecked && !res.disabled);
      if(typeof checked === 'boolean' && checked === false){
        checkItem.checked = false;
      }
      else if(list.some(res=>res.checked !== true)){
        checkItem.checked = false
      }else{
        checkItem.checked = true
      }
      if(checkItem.checked){
        this.judgeAllSelect();
      }else{
        this.judgeAllSelect(false);
      }
    },
    /**
     * 判断 是否全选（table维度）
     * @param checked
     */
    judgeAllSelect(checked){
      let list = this.currentSelectList;
      list = list.filter(res=>res.showChecked && !res.disabled);
      if(typeof checked === 'boolean' && checked === false){
        this.isAllSelect = false;
      }
      else if(list.some(res=>res.checked !== true)){
        this.isAllSelect = false
      }else{
        this.isAllSelect = true
      }
    },

    /**
     * 去开票
     * @param id
     * @param amount
     * @param currencyType
     */
    toInvoice(id = [], amount=0,currencyType){
      let key = ascendingStringId();
      sessionStorage.setItem(key,JSON.stringify({
        id,
        amount,
        currencyType,
      }));
      this.$router.push({
        name: "InvoiceApply",
        query: {
          key,
        },
      });
    },
    clickMultipleInvoices(){
      let ids = [];
      let totalMoney = 0;
      let currencyType = "";
      this.allSelectList.forEach(res=>{
        ids.push(res.id);
        totalMoney += parseFloat(res.money);
        if(!currencyType && res.currency) currencyType = res.currency;
      });
      this.toInvoice(ids,totalMoney,currencyType);
    },
  },
  computed: {
    // 是否可以合并支付
    isCanMergePay(){
      if(!this.allSelectList.length) return "至少勾选一个'待支付'费用";
      // let judge = this.allSelectList.every(res=>[1,'1'].includes(res.newStatus)); //更改为status
      let judge = this.allSelectList.every(res=>[1,'1'].includes(res.newStatus))
      if(!judge) return "含有非'待支付'状态费用";
      return false
    },
    // 是否可以合并开票
    isCanMergeInvoice(){
      if(!this.allSelectList.length) return "至少勾选一条【待开票】费用项";
      let flag;
      this.allSelectList.forEach(res=>{
        console.log('11',res)
        if(res.newStatus == 1 || (res.newStatus == 2 && res.publicTransferAccount == true && res.payType !=='D')){
          flag=true;
        }else {
          flag=false;
        }
      });
      console.log("flag",flag)
      if(!flag) {
        // this.$message.info("在线申请开票只支持对公转账的费用，请忽选择线上支付的费用")
        return '在线申请开票只支持对公转账的费用，请忽选择线上支付的费用'
      }

      let payStatus = [];
      this.allSelectList.forEach(res=>{
        if(!payStatus.includes(res.newStatus)) payStatus.push(res.newStatus);
      });
      if(payStatus.length>1) return "不同【支付状态】的费用项不能合并开票";

      let judge = this.allSelectList.every(res=>[0,'0'].includes(res.invoiceState));
      if(!judge) return "含有非'待开票'状态费用";

      let firstCurrency = "";
      let msg = "不同【币种】的费用项不能合并开票";
      judge = this.allSelectList.every((res,index)=>{
        if(!res.currency) {
          msg = "含有【币种】为空的费用项";
          return false;
        }
        if(index === 0) firstCurrency = res.currency;
        return firstCurrency === res.currency;
      });
      if(!judge) return msg;
      return false
    },
  },
  created() {

  },

  mounted() {
    if (sessionStorage.getItem("billOrderType")) {
      this.state = sessionStorage.getItem("billOrderType");
      sessionStorage.removeItem("billOrderType");

    }
    this.getListByParams();
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 0px 25px 30px;
}

/* .itemsStyle {
  border-bottom: solid 1px #eee;
  padding:8px 0
}
.itemsStyleNo {
  padding:8px 0
} */

.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
/deep/.el-pagination__total {
  line-height: 36px !important;
}

.myCursor {
  cursor: pointer;
}

/deep/ .el-form-item{
  margin-bottom: 8px;
  line-height: 28px;
}

/deep/ .el-input__inner{
  height: 34px;
}

  .table-button{
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/Mybill.vue